import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { Toast } from 'vant';
import javascriptBridge from '@/core/lib/javascript-bridge';
import { LOGIN } from '@/utils/consts/app-page';
import { getCookie } from '@/utils/helpers';
import { satisfiesAppVersion } from '@/utils/helpers/version';

Vue.use(Vuex);

const request = axios.create({
  baseURL: process.env.VUE_APP_UPLOAD,
  withCredentials: true,
  headers: {
    post: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  },
});

// 设置accessToken
const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';

// 设置refreshToken
const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';

// 设置loggerInfo
const SET_LOGGER_INFO = 'SET_LOGGER_INFO';

// 更换新单点登录sdk，做版本兼容
const newAccessToken = satisfiesAppVersion('<2.4.0') ? getCookie('accessToken') : getCookie('Magiccube-Token');

const state = {
  accessToken: newAccessToken,
  refreshToken: getCookie('refreshToken'),
  loggerInfoFromSwjApp: {}, // 透传原生的埋点信息参数
};
const mutations = {
  [SET_ACCESS_TOKEN](state, accessToken) {
    state.accessToken = accessToken;
  },
  [SET_REFRESH_TOKEN](state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  [SET_LOGGER_INFO](state, loggerInfoFromSwjApp) {
    state.loggerInfoFromSwjApp = loggerInfoFromSwjApp;
  },
};
const actions = {
  refreshToken: (() => {
    let refreshTokenPromise;
    return async ({ state, commit, dispatch }, options = {}) => {
      if (!refreshTokenPromise) {
        refreshTokenPromise = request.post('/sso-plus/oauth/refreshToken', {
          refreshToken: state.refreshToken,
        }).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            const { accessToken, refreshToken } = data;
            commit(SET_ACCESS_TOKEN, accessToken);
            commit(SET_REFRESH_TOKEN, refreshToken);
            dispatch('refreshLoggerInfo');
            return data;
          }
          if (code === 836 && !options.silent) {
            javascriptBridge.navigateTo({ name: LOGIN });
          }
          if (!options.silent) {
            Toast({
              position: 'bottom',
              message: '刷新身份验证失败',
            });
          }
          return Promise.reject(new Error('刷新身份验证失败'));
        }).finally(() => {
          refreshTokenPromise = undefined;
        });
      }
      return refreshTokenPromise;
    };
  })(),
  /**
   * 更新loggerInfo数据
   * @param {} param commit
   * @param {*} data loggerInfo
   */
  refreshLoggerInfo({ commit }) {
    javascriptBridge.callHandler('getLoggerInfo').then((loggerInfo) => {
      const { device_id: deviceId = '', login_User_Id: userId = '' } = loggerInfo;
      const params = {};
      if (deviceId) {
        params.deviceId = deviceId;
      }
      if (userId) {
        params.userId = userId;
      }

      commit(SET_LOGGER_INFO, params);
    });
  },
};

const authStore = new Vuex.Store({
  state,
  mutations,
  actions,
});

if (javascriptBridge.device.swjApp) {
  authStore.dispatch('refreshLoggerInfo');
}
export default authStore;
